export default {
    GET_ITEMS(state) {
        return state.invoices
    },
    GET_ITEM(state,id) {
      state.invoices.find((item) => item.id == id)
    },

    GET_ITEMS_ARTISAN(state) {
      return state.invoicesByArtisan
    },
}
